import { Skeleton } from 'shared/components/ui/Skeleton';

// Espelha <CourtSlotSection>: nome da quadra + preço e a fileira de 4 horários.
export function CourtSlotSkeleton() {
  return (
    <div aria-hidden="true" className="border-b border-border/70 py-4 last:border-b-0">
      <div className="flex items-center justify-between">
        <Skeleton className="h-3.5 w-36" />
        <Skeleton className="h-3.5 w-14" />
      </div>
      <div className="mt-3 grid grid-cols-4 gap-2">
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton key={index} className="h-10 rounded-lg" />
        ))}
      </div>
    </div>
  );
}
